<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Agent Detail</strong>
            <small class="pull-right" v-if="!add && model.created_at">Registed Time : ({{model.created_at | datetime}})</small>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_version" v-b-tooltip.hover>Build Version</label><br>
                <label for="ph_version">{{model.version}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_status" v-b-tooltip.hover>Status</label><br>
                <b-badge variant="primary" v-if="model.is_del">Disable</b-badge>
                <b-badge v-else variant="secondary">Enable</b-badge>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_version" v-b-tooltip.hover>Isolation</label><br>
                <b-badge variant="primary" v-if="model.setting.backup_mode">Enable</b-badge>
                <b-badge v-else variant="secondary">Disable</b-badge>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_info" v-b-tooltip.hover>Host@IPAddress</label><br>
                <label for="ph_info">{{model.name || 'None'}}@{{model.ip_addr}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_type" v-b-tooltip.hover>OS</label><br>
                <label for="ph_type">{{model.os_type}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_tag" v-b-tooltip.hover>TAG</label><br>
                <label for="ph_tag">{{model.tag}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <label for="ph_groupname" v-b-tooltip.hover>Company Name</label><br>
                <label for="ph_groupname">{{model && model.group && model.group.groupname || 'deleted group'}}</label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_service" v-b-tooltip.hover>Service</label><br>
                <label for="ph_service">{{model && model.group && model.group.service}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="Agent Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      This action cannot be reversed.
    </b-modal>
  </div>
</template>

<script>
import { Api } from '@/service';
import codes from '@/codes';

export default {
  data : () => {
    return {
      codes,
      confirm: false,
      add: false,
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'wsfinder_agent'}); },
    async remove() {
      try {
        let rs = await Api.Manager('agent', 'delete', { id : this.model.id })
        if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
        this.list(); this.$emit("refresh");
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    },
    async get({ id } = this.$route.params) {
      console.log('agent.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = default_model(); return; }
      else { this.add = false; }
      try{
        console.log(id)
        let rs = await Api.Manager_Call('wsfinder.agent', 'detail', { id : id })
        console.log(rs)

        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('agent.detail.vue', 'created'); },
  destroyed: function() { console.log('agent.detail.vue', 'destroyed'); },
  mounted: function() { console.log('agent.detail.vue', 'mounted'); this.get(this.$route.params); },
}
</script>
